"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignStatusToJSON = exports.CampaignStatusFromJSONTyped = exports.CampaignStatusFromJSON = exports.CampaignStatus = void 0;
/**
 * Current state of campaign.
 * @export
 */
exports.CampaignStatus = {
    Unset: 'UNSET',
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Archived: 'ARCHIVED',
    Unrecognized: 'UNRECOGNIZED'
};
function CampaignStatusFromJSON(json) {
    return CampaignStatusFromJSONTyped(json, false);
}
exports.CampaignStatusFromJSON = CampaignStatusFromJSON;
function CampaignStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CampaignStatusFromJSONTyped = CampaignStatusFromJSONTyped;
function CampaignStatusToJSON(value) {
    return value;
}
exports.CampaignStatusToJSON = CampaignStatusToJSON;
